import { AppLinkType } from "@app/enumerations";

export default class AppLink {

	public id: string | null = null;
	public label: string | null = null;
	public url: string | undefined | null = null;
	public appLinkType: AppLinkType | null = null;
	public subLinks: AppLink[] = [];

	public constructor() {

	}
};